/**
 * Interoperability Feature Routes
 *
 * Flat top-level routes (Interoperability is a standalone top-level nav section,
 * not nested under an existing shared layout like Settings' wizard). All
 * routes require the 'INTEROPERABILITY' entitlement — this key does not yet
 * exist in the backend entitlement matrix and must be provisioned there
 * before this module is usable outside local/mock development.
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';
import { INTEROPERABILITY_ENTITLEMENT, INTEROPERABILITY_ROUTE_NAMES } from './constants';

export const interoperabilityRoutes: RouteRecordRaw[] = [
  {
    path: '/interoperability',
    redirect: { name: INTEROPERABILITY_ROUTE_NAMES.userManagement },
    meta: {
      requiredEntitlement: INTEROPERABILITY_ENTITLEMENT,
    },
  },
  {
    path: '/interoperability/user-management',
    name: INTEROPERABILITY_ROUTE_NAMES.userManagement,
    component: () => import('./views/InteroperabilityUserManagementView.vue'),
    meta: {
      requiredEntitlement: INTEROPERABILITY_ENTITLEMENT,
      title: () => i18next.t('nav.interoperabilityUserManagement', 'Interoperability User Management'),
      breadcrumbs: [
        { label: () => i18next.t('nav.interoperability', 'Interoperability') },
        { label: () => i18next.t('nav.interoperabilityUserManagement', 'Interoperability User Management') },
      ],
    },
  },
  {
    path: '/interoperability/customization/field-mapping',
    name: INTEROPERABILITY_ROUTE_NAMES.fieldMapping,
    component: () => import('./views/FieldMappingView.vue'),
    meta: {
      requiredEntitlement: INTEROPERABILITY_ENTITLEMENT,
      title: () => i18next.t('nav.interoperabilityFieldMapping', 'Field Mapping'),
      breadcrumbs: [
        { label: () => i18next.t('nav.interoperability', 'Interoperability') },
        { label: () => i18next.t('nav.interoperabilityCustomization', 'Customization') },
        { label: () => i18next.t('nav.interoperabilityFieldMapping', 'Field Mapping') },
      ],
    },
  },
  {
    path: '/interoperability/customization/value-mapping',
    name: INTEROPERABILITY_ROUTE_NAMES.valueMapping,
    component: () => import('./views/ValueMappingView.vue'),
    meta: {
      requiredEntitlement: INTEROPERABILITY_ENTITLEMENT,
      title: () => i18next.t('nav.interoperabilityValueMapping', 'Value Mapping'),
      breadcrumbs: [
        { label: () => i18next.t('nav.interoperability', 'Interoperability') },
        { label: () => i18next.t('nav.interoperabilityCustomization', 'Customization') },
        { label: () => i18next.t('nav.interoperabilityValueMapping', 'Value Mapping') },
      ],
    },
  },
  {
    path: '/interoperability/transaction-monitoring',
    name: INTEROPERABILITY_ROUTE_NAMES.transactionMonitoring,
    component: () => import('./views/TransactionMonitoringView.vue'),
    meta: {
      requiredEntitlement: INTEROPERABILITY_ENTITLEMENT,
      title: () => i18next.t('nav.interoperabilityTransactionMonitoring', 'Transaction Monitoring'),
      breadcrumbs: [
        { label: () => i18next.t('nav.interoperability', 'Interoperability') },
        { label: () => i18next.t('nav.interoperabilityTransactionMonitoring', 'Transaction Monitoring') },
      ],
    },
  },
];
